<template>
    <div>
        <div class="card-header">
            <h3 v-if="typeSetting == 'sender'" class="mb-0 title--screen">{{ $t('managerForm.email.senderEmail') }}</h3>
            <h3 v-if="typeSetting == 'reply'" class="mb-0 title--screen">{{ $t('managerForm.email.replyEmail') }}</h3>
        </div>
        <div class="d-flex justify-content-center mt-5">
            <button type="button" class="btn btn-outline-primary w-25" @click="openModalEdit({}, 'create')">
                <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                新規登録
            </button>
        </div>
        <div class="card-body">
            <table class="table table-bordered">
                <thead>
                    <th v-for="(item, k) in configs.configTableEmailSetting.headers" :key="k" style="background: #ededed; max-width: 200px">
                        <div class="d-flex align-items-center">{{ item.label }}</div>
                    </th>
                </thead>
                <tbody>
                    <tr v-for="(item, k) in listEmail" :key="k">
                        <td>{{ item.email_address }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.comment }}</td>
                        <td>
                            <div class="text-left text-nowrap">
                                <a href="javascript:void(0)" class="btn btn-common-sml btn-primary mr-2" @click="openModalEdit(item, 'edit')"
                                    ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                >
                                <a href="javascript:void(0)" class="btn btn-common-sml btn-danger" @click="deleteDomain(item.id)"
                                    ><i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}</a
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ModalCommon
            v-if="configs.configModalDomainEdit.model"
            :id="`ModalDomainEdit`"
            :config="configs.configModalDomainEdit"
            @close="closeModal"
            @save="handleUpdateDomain"
        >
            <template>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">{{ $t('managerForm.email.email') }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="currentEmail.email_address"
                                    :config.sync="configFormEmail.configFieldEmail"
                                    @blur="validateField(configFormEmail.configFieldEmail)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3">{{ $t('managerForm.email.title') }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="currentEmail.title"
                                    :config.sync="configFormEmail.configFieldTitle"
                                    @blur="validateField(configFormEmail.configFieldTitle)"
                                />
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">{{ $t('managerForm.email.comment') }}</label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="currentEmail.comment"
                                    :config.sync="configFormEmail.configFieldComment"
                                    @blur="validateField(configFormEmail.configFieldComment)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';
import ModalCommon from '@/components/Modal/main.vue';
import { onHandleShowConfirm } from '@/utils/handlers';

import { validateAllField, validateField } from '@/utils/validate';
import { showMessage } from '@/utils/messages';
import { configFormEmail, configs } from '../../constants';
import _ from 'lodash';

export default {
    name: 'EmailSetting',
    components: {
        ModalCommon,
        InputText
    },
    props: {
        typeSetting: {
            type: String
        }
    },
    data() {
        return {
            configFormEmail: configFormEmail(),
            configs,
            listEmail: [],
            currentEmail: {
                email_address: '',
                title: '',
                comment: ''
            }
        };
    },
    methods: {
        ...managerFormMethods,
        validateField,
        validateAllField,
        async onGetListEmail() {
            try {
                let dataRes;
                switch (this.typeSetting) {
                    case 'sender':
                        dataRes = await this.getListEmailSender();
                        break;
                    case 'reply':
                        dataRes = await this.getListEmailReply();
                        break;
                }
                this.listEmail = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        },
        initEmail() {
            return {
                email_address: '',
                title: '',
                comment: ''
            };
        },
        resetModal() {
            this.currentEmail = this.initEmail();
            this.configFormEmail = configFormEmail();
        },
        openModalEdit(item, action) {
            this.configs.configModalDomainEdit.model = true;
            if (action === 'edit') {
                this.configs.configModalDomainEdit.title = this.$t('btn.edit');
                this.currentEmail = _.cloneDeep(item);
            } else {
                this.configs.configModalDomainEdit.title = '作成';
            }
        },
        closeModal() {
            this.configs.configModalDomainEdit.model = false;
            this.resetModal();
        },
        async handleUpdateDomain() {
            let check = validateAllField(this.configFormEmail);
            const payload = {
                id: this.currentEmail.id,
                data: {
                    email_address: this.currentEmail.email_address,
                    title: this.currentEmail.title,
                    comment: this.currentEmail.comment
                }
            };
            if (!check) return;
            try {
                let dataRes;
                switch (this.typeSetting) {
                    case 'sender':
                        if (this.configs.configModalDomainEdit.title === '作成') {
                            dataRes = await this.registerEmailSender(payload.data);
                        } else {
                            dataRes = await this.updateEmailSender(payload);
                        }
                        break;
                    case 'reply':
                        if (this.configs.configModalDomainEdit.title === '作成') {
                            dataRes = await this.registerEmailReply(payload.data);
                        } else {
                            dataRes = await this.updateEmailReply(payload);
                        }
                        break;
                }
                if (dataRes.code == 200) {
                    this.configs.configModalDomainEdit.model = false;
                    if (this.configs.configModalDomainEdit.title === '作成') {
                        showMessage(dataRes.code, this.$bvToast, this.$t('managerForm.email.registEmailSuccess'));
                    } else {
                        showMessage(dataRes.code, this.$bvToast, this.$t('managerForm.email.updateEmailSuccess'));
                    }
                    this.resetModal();
                    this.onGetListEmail();
                } else {
                    if (dataRes.message === 'email_address.domain.not_found') {
                        showMessage(
                            dataRes.code,
                            this.$bvToast,
                            'ドメインがシステムに登録されていません。送信者に追加する前に、ドメインを登録してください。'
                        );
                    } else if (dataRes.message === 'email_address.unique') {
                        showMessage(dataRes.code, this.$bvToast, 'メールアドレスが既に存在しています');
                    } else {
                        showMessage(dataRes.code, this.$bvToast, this.$t(dataRes.message));
                    }
                }
            } catch (error) {
                console.log('error', error);
            }
        },
        async deleteDomain(id) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'このメールを削除してもよろしいですか',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'OK'
            });
            if (confirmDelete) {
                try {
                    let response;
                    switch (this.typeSetting) {
                        case 'sender':
                            response = await this.deleteEmailSender(id);
                            break;
                        case 'reply':
                            response = await this.deleteEmailReply(id);
                            break;
                    }
                    if (response.code !== 200) return;
                    showMessage(response.code, this.$bvToast, 'メールが削除されました。');
                    this.resetModal();
                    this.onGetListEmail();
                } catch (error) {
                    console.log('error', error);
                }
            }
        }
    },
    async mounted() {
        await this.onGetListEmail();
    }
};
</script>

<style lang="scss" scoped>
td {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
